// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__2MBFI","noHoverBg":"CellularCapability_noHoverBg__2MmMT"};